import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchJson, assetUrl } from "../lib/api";
import { formatDateFR } from "../lib/format";
import Countdown from "../components/Countdown";

export default function PlaceholderPage({
  eyebrow,
  title,
  subtitle,
  showNextEvent = false,
  testId,
}) {
  const [nextEvent, setNextEvent] = useState(null);

  useEffect(() => {
    if (!showNextEvent) return;
    (async () => {
      try {
        const events = await fetchJson("/events", { status: "upcoming" });
        if (events && events.length > 0) setNextEvent(events[0]);
      } catch (_) {
        // silent
      }
    })();
  }, [showNextEvent]);

  return (
    <section
      data-testid={testId || "placeholder-page"}
      className="max-w-[1400px] mx-auto px-4 md:px-8 py-20 md:py-32"
    >
      <p className="text-xs uppercase tracking-[0.3em] text-gold font-stats">
        {eyebrow}
      </p>
      <h1 className="mt-6 font-display font-black text-5xl md:text-8xl leading-[0.9] text-white">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-6 max-w-2xl text-neutral-400 text-base md:text-lg leading-relaxed">
          {subtitle}
        </p>
      )}

      {showNextEvent && nextEvent && (
        <div className="mt-14 border-t border-neutral-900 pt-10">
          <p className="text-xs uppercase tracking-[0.3em] text-neutral-600 font-stats">
            Prochain événement
          </p>
          <h3 className="mt-3 font-display font-black text-3xl md:text-5xl text-white">
            {nextEvent.name}
          </h3>
          <p className="mt-2 text-neutral-500 text-sm font-stats uppercase tracking-widest">
            {formatDateFR(nextEvent.date)} · {nextEvent.city}
          </p>
          <div className="mt-6">
            <Countdown target={nextEvent.date} testId="live-next-countdown" />
          </div>
          <Link
            to={`/events/${nextEvent.slug}`}
            data-testid="live-next-event-link"
            className="inline-flex items-center gap-3 mt-8 px-6 py-3 border border-white text-white font-display uppercase tracking-widest text-sm hover:bg-white hover:text-black transition-colors duration-200"
          >
            Voir la fight card →
          </Link>
        </div>
      )}
    </section>
  );
}
